import React, { useState, useEffect } from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import classNames from 'classnames'
import { request } from 'meinian-package/src/utils'
import { CommonInspirationBaseCard } from '../../workbench/commonInspiration'
import BaseDrawer from '../../inspiration/baseDrawer'
import styles from './index.module.less'

const PastDrawer = ({ onClose, visible }) => {
  const [data, setData] = useState<any>([])

  const fetchData = async () => {
    const result:any = await request.get('/zhikuan/mn/recommend/list-daily-recommend')
    setData(result?.map(item => ({ ...item, coverImgUrl: item.imageUrl, name: item.dailyName, })))
  }

  useEffect(() => {
    fetchData()
  }, [])

  return <BaseDrawer
    onClose={onClose}
    width={440}
    visible={visible}
    title="往期「专属推荐」"
  >
    <div className={styles.pastDrawerListWrap}>
      {data?.map(item => <CommonInspirationBaseCard
        itemData={item}
        className={classNames(styles.officialPastItem, 'fill-white-bg')}
        onClick={() => {
          window.open(`/meinian/home/coll/exclusive-detail?id=${item.blogId}&name=${item.dailyName}`)
        }}
      />)}
    </div>
  </BaseDrawer>
}

export default () => { // 官方灵感集往期推荐
  const [visible, setVisible] = useState(false)
  return <>
    <Button
      type="normal"
      style={{ padding: '2px 8px', marginLeft: '24px' }}
      onClick={() => setVisible(true)}
    >查看往期<Icon type="m-Vxing_you" /></Button>
    <PastDrawer
      visible={visible}
      onClose={() => setVisible(false)}
    />
  </>
}
